import { render, staticRenderFns } from "./CurrentGroupRow.vue?vue&type=template&id=92e84b9e&scoped=true&"
import script from "./CurrentGroupRow.vue?vue&type=script&lang=js&"
export * from "./CurrentGroupRow.vue?vue&type=script&lang=js&"
import style0 from "./CurrentGroupRow.vue?vue&type=style&index=0&id=92e84b9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e84b9e",
  null
  
)

export default component.exports